import { render, staticRenderFns } from "./EventGage.vue?vue&type=template&id=13f8e986&scoped=true"
import script from "./EventGage.vue?vue&type=script&lang=js"
export * from "./EventGage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f8e986",
  null
  
)

export default component.exports